export interface ShareResponseDto {
    failedShares: string[];
}
